import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(() => ({
    root: {},

    title: {
        fontSize: '20px',
    },
    leftIcon: {
        // marginRight: theme.spacing.unit,
      },

}));


export default function Header(props) {
    const { className, ...rest } = props;
    const classes = useStyles();
    const [role, setRole] = useState(window.localStorage.getItem("role"));
    useEffect(()=>{
        setRole(window.localStorage.getItem("role"));
    });
    return (
        <div {...rest} className={clsx(classes.root, className)} >
            <Grid alignItems="flex-end" container justify="space-between" spacing={3} >
                <Grid item>
                    
                   
                </Grid>
                <Grid item>
                    { role == 'superadmin' && (
                    <Link to ="/showroom/createshowroom">
                        <Button variant="contained" >
                        <AddIcon className={classes.leftIcon}/>
                            Create New Showroom
                        </Button>
                    </Link>)}
                    
                </Grid>
            </Grid>
            <div style={{marginBottom: "20px"}}></div>
        </div>
        
    )
}
